<form
  class="jumbotron"
  #loginForm="ngForm"
  ngNativeValidate
  (ngSubmit)="loginUser(loginForm)">

  <h1 class="text-center">Login Form</h1>
  <label class="form-group">
    <span class="text-dark">Login:</span>
    <input
      type="text"
      name="login"
      class="form-control"
      required ngModel>
  </label>
  <label class="form-group">
    <span class="text-dark">Password:</span>
    <input
      type="password"
      name="password"
      class="form-control"
      required ngModel>
    <small class="error-message text-danger">
      {{ passwordErrorMessage }}
    </small>
  </label>
  <input
    type="submit"
    value="Sign In"
    class="btn btn-primary"
    [disabled]="loginForm.invalid">
</form>
